import * as React from 'react';

interface NotAuthorizedProps {
  onLoading: (loading: boolean) => void;
}
interface NotAuthorizedState {}

export class NotAuthorized extends React.Component<NotAuthorizedProps, NotAuthorizedState> {
  constructor(props: NotAuthorizedProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() { this.props.onLoading(false); }

  render() {
    return (
      <section className="panel panel-error">
        <header className="panel-heading">
          <i className="fa fa-minus-circle"/>
          <h2>Not Authorized</h2>
        </header>

        <div className="panel-body">
          <p>It looks like you do not have permission to view this page.</p>
          <p>
            If you believe you should have access or have any questions, please contact{' '}
            <a href="mailto:gsit@ucdavis.edu">tech support</a>.
          </p>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/error/NotAuthorized.tsx